export enum SpeciesCode {
  Unknown = 'unknown',
  Dog = 'dog',
  Cat = 'cat',
}
